import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Driver } from '@/core/domain'

interface DashboardSignaturesTabProps {
  drivers: Driver[]
}

export default function DashboardSignaturesTab({
  drivers,
}: DashboardSignaturesTabProps) {
  const driversWithSubscription = drivers.filter(
    (driver) =>
      driver.subscription &&
      driver.subscription.restantDays !== undefined &&
      driver.subscription.restantDays > 0
  )

  return (
    <Card>
      <CardHeader>
        <CardTitle>Assinaturas</CardTitle>
        <CardDescription>
          Detalhamento das assinaturas dos motoristas
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Motorista</TableHead>
              <TableHead>Valor da Assinatura</TableHead>
              <TableHead>Dias Restantes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {driversWithSubscription.length > 0 ? (
              driversWithSubscription.map((driver, index) => (
                <TableRow key={driver.id || index}>
                  <TableCell>
                    {driver.fullName || driver.firstName || '-'}
                  </TableCell>
                  <TableCell>
                    R$ {driver.subscription?.value?.toFixed(2) || '0.00'}
                  </TableCell>
                  <TableCell>
                    {driver.subscription?.restantDays || 0} dias
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={3}
                  className="text-center text-muted-foreground"
                >
                  Nenhuma assinatura ativa
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}
